<script>
import baseList from "@/views/components/base/baseList.vue";
import config from "@/../config";

export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "sysDemand",
        key: "id",
        url: {
          list: `/admin/system/sysDemand/myList`,
          del: `/admin/system/sysDemand/delete`,
        },
        output: false,
      },
      menus: [
        {
          label: "所有需求",
          name: "demand_management_list",
          auth: "system/demand_management/index",
        },
        {
          label: "我负责的",
          name: "demand_management_myTake",
          auth: "system/demand_management/index",
        },
        {
          label: "我提交的",
          name: "demand_management_mySubmit",
          auth: "system/demand_management/index",
        },
      ],
      actions: [
        {
          label: "新增需求",
          icon: "md-add",
          onClick: this.toAdd,
          auth: "",
          type: "info",
        },
      ],
      filters: [
        {
          label: "状态",
          name: "state",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: 0,
              name: "待受理",
            },
            {
              value: 1,
              name: "不予受理",
            },
            {
              value: 2,
              name: "处理中",
            },
            {
              value: 3,
              name: "处理完成",
            },
            {
              value: 4,
              name: "待立项",
            },
          ],
        },
        {
          label: "负责人",
          name: "currentAssigneeName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "需求科室",
          name: "deskName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "任务内容",
          name: "applyContent",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
      ],
      tableCols: [
        {
          type: "index",
          title: "序号",
          width: 70,
          align: "center",
        },
        {
          title: "任务内容",
          key: "applyContent",
          minWidth: 300,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.content;
            const textTime = row.handleDuration;

            let tempDescr;
            let teColor;
            if (text != null) {
              if (textTime != null) {
                let totalSeconds = Math.floor(textTime / 1000);
                let totalMinutes = Math.floor(totalSeconds / 60);
                let totalHours = Math.floor(totalMinutes / 60);
                let days = Math.floor(totalHours / 24);

                let minutes = totalMinutes % 60;
                let hours = totalHours % 24;

                let parts = [];
                if (days) parts.push(days + "天");
                if (hours || parts.length) parts.push(hours + "时");
                if (minutes || parts.length) parts.push(minutes + "分");

                tempDescr = "[" + (parts.join("") || "0分") + "]" + text;
                // if (row.status == 1) {
                //   teColor = "red";
                // }
              } else {
                tempDescr = "[" + 0 + "天" + 0 + "时" + 0 + "分]" + text;
              }
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    // color: teColor,
                  },
                  domProps: {
                    title: tempDescr,
                  },
                },
                tempDescr
              ),
            ]);
          },
        },
        {
          title: "需求科室",
          key: "deskName",
          width: 200,
          align: "center",
          // tree: true,
        },
        {
          title: "负责人",
          key: "currentAssigneeName",
          width: 120,
          align: "center",
          // tree: true,
        },
        {
          title: "状态",
          key: "status",
          width: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.status;
            if (text == 0) {
              return <span>待受理</span>;
            } else if (text == 1) {
              return <span>不予受理</span>;
            } else if (text == 2) {
              return <span>处理中</span>;
            } else if (text == 3) {
              return <span>处理完成</span>;
            } else if (text == 4) {
              return <span>待立项</span>;
            }
          },
        },
        {
          title: "操作",
          align: "center",
          width: 220,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = [];
              const row = param.row;

              if (
                row.currentAssigneeId == $utils.data.get("auth", "uid") &&
                row.status != 1 &&
                row.status != 3 &&
                row.status != 4
              ) {
                return (
                  <Button
                    size="small"
                    onClick={() => this.handleEdit(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                      display: row.state === 2 ? "none" : "",
                    }}
                  >
                    去处理
                  </Button>
                );
              }
            },
            (vm, h, currentRow, param) => {
              // let directives = [];
              const row = param.row;
              return (
                <Button
                  size="small"
                  onClick={() => this.selectChange(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    margin: "0 10px",
                  }}
                >
                  详情
                </Button>
              );
            },
            "delete",
          ],
          auth: {
            edit: "system/sysTask/edit",
          },
        },
      ],
    };
  },
  created() {},
  methods: {
    toAdd() {
      $utils.url.push({
        name: "add_demand_management",
        query: { action: "add" },
      });
    },
    handleEdit(row) {
      let kv = row.id;
      $utils.url.push({
        name: "edit_demand_management",
        query: { action: "edit", kv: kv },
      });
    },
    selectChange(row) {
      let kv = row.id;
      $utils.url.push({
        name: "info_demand_management",
        query: { action: "view", kv: kv },
      });
    },
  },
};
</script>
<style scoped></style>
